import { Box, Stack } from '@mui/material';
import { theme } from '@src/theme';
import { border } from '@src/utils';

const ContentItem = ({ maxHeight }) => {
  return <Box maxHeight={maxHeight} height="100%" sx={{ backgroundColor: theme.palette.secondary['200'] }} />;
};
const myArray = Array.from({ length: 15 }, (_, index) => index + 1);

export const ContentLoading = () => {
  return (
    <Stack width="100%" height="calc(100% - 90px)" direction="row" sx={{ top: 0, left: 0 }}>
      <Stack width="50%" height="100%" gap="18px" padding="24px" borderRight={border}>
        <ContentItem maxHeight="180px" />
        <ContentItem maxHeight="284px" />
        <ContentItem maxHeight="284px" />
      </Stack>
      <Stack width="50%" height="100%" padding="24px" gap="6px">
        {myArray.map(count => (
          <ContentItem key={count} maxHeight="42px" />
        ))}
      </Stack>
    </Stack>
  );
};
